import styled from 'styled-components';

export function InfoCards({ items }) {
  return (
    <CardStyle>
      {items.map(item => (
        <div key={item.label} className="item">
          <div className="value">
            <p>{item.value}</p>
            {item.icon}
          </div>
          <p className="label">{item.label}</p>
        </div>
      ))}
    </CardStyle>
  );
}

const CardStyle = styled.div`
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  display: grid;
  margin-top: 12px;
  .item {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #f1f3f5;
    background: #fff;
    .value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      svg {
        font-size: 20px;
        color: #228be6;
      }
      p {
        color: #000;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
      }
    }
    .label {
      margin-top: 12px;
      color: #adb5bd;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
`;
